module.exports = __webpack_public_path__ + "img/new-step12.10a5e675.jpg";